import { formatDecimalNumber } from "../../utils/common";
import { useCurrency } from "./useCurrency";

export const useCurrencyFormat = () => {
  const { customerCurrencySymbol } = useCurrency();

  return (cost: number) => `${customerCurrencySymbol}${formatDecimalNumber(cost, 0)}`;
};
